import { render, staticRenderFns } from "./CopyRoom.vue?vue&type=template&id=0b2fafa4&"
import script from "./CopyRoom.vue?vue&type=script&lang=js&"
export * from "./CopyRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports